import "./css/style.css";
import "./js/basic.js";
import "./js/contact.js";

// swiper
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
const swiper = new Swiper('.swiper', {
	effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
	loop: true,
	speed: 800,
  pagination: {
		el: '.slider__nav .swiper-pagination',
		clickable: true,
		renderBullet: function(index,className) {
			return '<div class="' + className + '"><svg viewBox="0 0 116 116"><circle cx="58" cy="58" r="55" /></svg></div>'
		}
  },
	autoplay: {
		delay: 5000,
	}
});
const homeswiper = new Swiper('.home-swiper', {
	loop: true,
	speed: 800,
  pagination: {
		el: '.swiper-pagination',
    type: 'fraction',
  },
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	autoplay: {
		delay: 3500,
	}
});
// TODO:複数設置がある場合書き換える
const slider = new Swiper('.content-slider-swiper', {
	loop: true,
	speed: 800,
  pagination: {
		el: '.content-slider__nav .swiper-pagination',
  },
	navigation: {
		nextEl: ".content-slider__nav .swiper-button-next",
		prevEl: ".content-slider__nav .swiper-button-prev",
	},
	autoplay: {
		delay: 3500,
	}
});

// lightbox
import GLightbox from 'glightbox'
import './css/vendor/glightbox.css'
const lightbox = GLightbox({
	loop: true
})